import React from "react";
import { CATEGORIES } from "./categories";

// Rub el Hizb: two overlapping squares forming the classic 8-point Islamic star.
export const IslamicStar = ({ className = "", active = false }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
    <g fill={active ? "rgba(212,175,55,0.22)" : "rgba(212,175,55,0.08)"} stroke="#D4AF37" strokeWidth={active ? 2.2 : 1.4}>
      <rect x="20" y="20" width="60" height="60" />
      <rect x="20" y="20" width="60" height="60" transform="rotate(45 50 50)" />
    </g>
    <circle cx="50" cy="50" r="17" fill="none" stroke="#D4AF37" strokeOpacity="0.5" strokeWidth="1" />
  </svg>
);

export const CategoryTiles = ({ value, onChange, counts = {} }) => (
  <div className="flex lg:justify-between gap-3 sm:gap-4 overflow-x-auto pb-3 -mx-1 px-1 snap-x" data-testid="shop-category-tiles">
    {[{ key: "", label: "All Collection", ar: "الكل" }, ...CATEGORIES].map((c) => {
      const on = value === c.key;
      return (
        <button key={c.key || "all"} onClick={() => onChange(c.key)} data-testid={`category-chip-${c.key || "all"}`}
          className={`group snap-start flex-shrink-0 w-[104px] sm:w-[108px] flex flex-col items-center rounded-2xl border px-2 pt-3 pb-2.5 transition-[transform,border-color,background-color] duration-300 hover:-translate-y-1 ${on ? "border-[#D4AF37] bg-[#0D382B]" : "border-[#D4AF37]/20 bg-[#0B0F0D]/60 hover:border-[#D4AF37]/60"}`}>
          <span className="relative w-14 h-14 flex items-center justify-center">
            <IslamicStar active={on} className="absolute inset-0 w-full h-full transition-transform duration-700 group-hover:rotate-45" />
            <span className="relative font-arabic text-[15px] leading-none text-[#FFE9A8]" dir="rtl">{c.ar}</span>
          </span>
          <span className={`mt-2 text-[11px] font-semibold text-center leading-tight ${on ? "text-[#FFE9A8]" : "text-[#F5EFE6]/85"}`}>{c.label}</span>
          {c.key && counts[c.key] > 0 && <span className="text-[9px] text-[#A3B8B0] mt-0.5">{counts[c.key]} {counts[c.key] === 1 ? "item" : "items"}</span>}
        </button>
      );
    })}
  </div>
);
